import Card from './card.vue';
import Title from '@/components/Title/index.vue';
export default {
  components: {
    Title,
    Card
  },
  data() {
    return {
      imgUrl: [require('@/assets/images/solution/health-care/healthcareSolutions-imgSolutions.png'), require('@/assets/images/solution/health-care/healthcareSolutions-medicalSolutions.png'), require('@/assets/images/solution/health-care/healthcareSolutions-researchSolutions.png')],
      diagnosisSolutionsList: [{
        img: require('@/assets/images/solution/health-care/healthcareSolutions-digestive.png'),
        desc1: '消化内镜智能诊断系统 '
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-radiology.png'),
        desc1: '放射智能诊断系统'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-pathology.png'),
        desc1: '病理智能标注平台'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-radio.png'),
        desc1: '放射影像质控系统'
      }],
      innovationSolutionsList: [{
        img: require('@/assets/images/solution/health-care/healthcareSolutions-management.png'),
        desc1: '科研大数据管理平台'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-recommendation.png'),
        desc1: '科研智能推荐系统'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-analysis.png'),
        desc1: '大数据规则挖掘分析系统'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-teaching.png'),
        desc1: '病理教学系统'
      }],
      assistantSolutionsList: [{
        img: require('@/assets/images/solution/health-care/healthcareSolutions-EMR.png'),
        desc1: '电子病历语音转写系统'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-MWR.png'),
        desc1: '移动查房语音录入系统'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-follow.png'),
        desc1: '医疗智能随访系统'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-education.png'),
        desc1: '医学智能宣教系统'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-aiService.png'),
        desc1: '智能客服系统'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-recognition.png'),
        desc1: '医疗文档智能识别'
      }]
    };
  }
};